import Vue from "vue";
import Vuex from "vuex";
import app from "../app/store";
import auth from "../app/auth/store";
import records from "../app/records/store";
import admin from "../app/admin/store";
import patientRecords from "../app/patient-records/store";
import {
  allTypes,
  allRootNodes,
  allUoms,
  allGlossaries,
  allRootCats,
  allTemplates,
  postNewCategory,
  addCatToRecord,
  createTemplate,
  cloneRecordFromTemplate,
  postNewRecord,
  removeNode,
  postNewUom,
  updateRecNode,
  cdgGetAnalysisCats,
  cdgGetStateId,
  cdgFetchCommonalities,
  allOrdersFromRecord
} from "../app/utils/interface";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    app,
    auth,
    records,
    admin,
    patientRecords,
    allTypes,
    allRootNodes,
    allUoms,
    allGlossaries,
    allRootCats,
    allTemplates,
    postNewCategory,
    addCatToRecord,
    createTemplate,
    cloneRecordFromTemplate,
    postNewRecord,
    removeNode,
    postNewUom,
    updateRecNode,
    cdgGetAnalysisCats,
    cdgGetStateId,
    cdgFetchCommonalities,
    allOrdersFromRecord
  }
  //strict: debug,
});
